import { render, staticRenderFns } from "./PublicatorDeleteDialog.vue?vue&type=template&id=4aadddfe&scoped=true"
import script from "./PublicatorDeleteDialog.vue?vue&type=script&lang=js"
export * from "./PublicatorDeleteDialog.vue?vue&type=script&lang=js"
import style0 from "./PublicatorDeleteDialog.vue?vue&type=style&index=0&id=4aadddfe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aadddfe",
  null
  
)

export default component.exports